// src/utils/ChallengeUtils.tsx

import { Challenge } from '../challenge.types.';

export const getChallengeStatus = (challenge: Challenge): string => {
  if (!challenge) return 'unknown';
  
  const now = new Date();
  const startDate = new Date(challenge.from_datetime);
  const endDate = new Date(challenge.to_datetime);
  
  if (now < startDate) {
    return 'yet to start';
  } else if (now > endDate) {
    return 'ended';
  } else {
    return 'live';
  }
};

export const getChallengeStartDate = (challenge: Challenge): string => {
  return challenge.from_datetime;
};

export const getChallengeEndDate = (challenge: Challenge): string => {
  return challenge.to_datetime;
};

export const getMetricIcon = (metricType: string): string => {
  switch (metricType) {
    case 'steps': return '👟';
    case 'distance': return '🏃‍♂️';
    case 'caloriesburned': return '🔥';
    default: return '🎯';
  }
};

export const getGoalText = (challenge: Challenge | null): string => {
  if (!challenge) return '';
  return `${challenge.goal_count.toLocaleString()}`;
};

export const getGoalUnit = (challenge: Challenge | null): string => {
  if (!challenge) return '';
  switch (challenge.metric_type) {
    case 'steps': return 'steps per day';
    case 'distance': return 'km per day';
    case 'caloriesburned': return 'calories per day';
    default: return 'per day';
  }
};

export const formatDateRange = (startDate: string, endDate: string): string => {
  const start = new Date(startDate).toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric' 
  });
  const end = new Date(endDate).toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric' 
  });
  return `${start} To ${end}`;
};